import { render, staticRenderFns } from "./section.vue?vue&type=template&id=368e0db4&"
import script from "./section.vue?vue&type=script&lang=js&"
export * from "./section.vue?vue&type=script&lang=js&"
import style0 from "./section.vue?vue&type=style&index=0&id=368e0db4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368e0db4')) {
      api.createRecord('368e0db4', component.options)
    } else {
      api.reload('368e0db4', component.options)
    }
    module.hot.accept("./section.vue?vue&type=template&id=368e0db4&", function () {
      api.rerender('368e0db4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/SalesStatistics/section.vue"
export default component.exports